import { getBalancesOptions } from "@/api/balances";
import { ErrorBoundary } from "@/shared/suspense/ErrorBoundary";
import { LoadingFallback } from "@/shared/suspense/LoadingFallback";
import { Anchor, Grid, Group, Paper, Table, Text, Title } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { formatUnits } from "viem";

export const Route = createFileRoute("/balances")({
	loader: ({ context }) => {
		context.queryClient.ensureQueryData(getBalancesOptions());
	},
	component: RouteComponent,
	errorComponent: ErrorBoundary,
	pendingComponent: LoadingFallback,
});

export default function RouteComponent() {
	const { data: balances } = useSuspenseQuery(getBalancesOptions());

	return (
		<div className="pb-4">
			<Title order={1} mb="md">
				Token Balances
			</Title>

			<Grid gutter="md" justify="start">
				{Object.entries(balances ?? {}).map(
					([name, { address, ETH, USDC, LINK, CREDIT }]) => (
						<Grid.Col key={name} span={{ base: 12, sm: 6, lg: 4 }}>
							<Paper withBorder shadow="sm" radius="md" p="md">
								<div>
									<Text fw={600} size="lg" mb="xs">
										{name}
									</Text>
									<Group gap="xs">
										<Text size="xs" c="dimmed" lineClamp={2}>
											<code>{address}</code>
										</Text>
										<Anchor
											href={`https://basescan.org/address/${address}`}
											target="_blank"
											rel="noopener noreferrer"
											onClick={(e) => e.stopPropagation()}
										>
											<IconExternalLink size={16} />
										</Anchor>
									</Group>
								</div>

								<Table mt="md" highlightOnHover striped>
									<Table.Tbody>
										<Table.Tr>
											<Table.Td>
												<Text size="sm" c="dimmed">
													ETH
												</Text>
											</Table.Td>
											<Table.Td>
												<Text size="sm" fw={500} ta="right">
													{ETH === undefined ? "-" : formatUnits(ETH, 18)}
												</Text>
											</Table.Td>
										</Table.Tr>
										<Table.Tr>
											<Table.Td>
												<Text size="sm" c="dimmed">
													LINK
												</Text>
											</Table.Td>
											<Table.Td>
												<Text size="sm" fw={500} ta="right">
													{LINK === undefined ? "-" : formatUnits(LINK, 18)}
												</Text>
											</Table.Td>
										</Table.Tr>
										<Table.Tr>
											<Table.Td>
												<Text size="sm" c="dimmed">
													USDC
												</Text>
											</Table.Td>
											<Table.Td>
												<Text size="sm" fw={500} ta="right">
													{USDC === undefined ? "-" : formatUnits(USDC, 6)}
												</Text>
											</Table.Td>
										</Table.Tr>
										<Table.Tr>
											<Table.Td>
												<Text size="sm" c="dimmed">
													CREDIT
												</Text>
											</Table.Td>
											<Table.Td>
												<Text size="sm" fw={500} ta="right">
													{CREDIT === undefined ? "-" : formatUnits(CREDIT, 18)}
												</Text>
											</Table.Td>
										</Table.Tr>
									</Table.Tbody>
								</Table>
							</Paper>
						</Grid.Col>
					),
				)}
			</Grid>
		</div>
	);
}
